import React, { useState } from 'react';
import './Installation.css';

function Installation() {
  const [os, setOs] = useState('windows');

  return (
    <section id="instalacio" className="installation">
      <div className="container">
        <div className="section-header">
          <span className="section-tag">Pas 1</span>
          <h2 className="section-title">Instal·lacio i <span className="gold">configuracio</span></h2>
          <p className="section-desc">
            Abans de comenc&#807;ar, necessitem instal·lar i configurar les eines basiques.
          </p>
        </div>

        {/* STEP 1: Install Git */}
        <div className="install-step">
          <div className="step-number">1</div>
          <div className="step-content">
            <h3>Instal·lar Git</h3>
            <p>Git es el sistema de control de versions. Es l'eina que executarem des del terminal.</p>

            <div className="os-tabs">
              <button className={`os-tab ${os === 'windows' ? 'active' : ''}`} onClick={() => setOs('windows')}>
                <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor"><path d="M0 3.449L9.75 2.1v9.451H0m10.949-9.602L24 0v11.4H10.949M0 12.6h9.75v9.451L0 20.699M10.949 12.6H24V24l-12.9-1.801"/></svg>
                Windows
              </button>
              <button className={`os-tab ${os === 'mac' ? 'active' : ''}`} onClick={() => setOs('mac')}>
                <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor"><path d="M18.71 19.5c-.83 1.24-1.71 2.45-3.05 2.47-1.34.03-1.77-.79-3.29-.79-1.53 0-2 .77-3.27.82-1.31.05-2.3-1.32-3.14-2.53C4.25 17 2.94 12.45 4.7 9.39c.87-1.52 2.43-2.48 4.12-2.51 1.28-.02 2.5.87 3.29.87.78 0 2.26-1.07 3.8-.91.65.03 2.47.26 3.64 1.98-.09.06-2.17 1.28-2.15 3.81.03 3.02 2.65 4.03 2.68 4.04-.03.07-.42 1.44-1.38 2.83M13 3.5c.73-.83 1.94-1.46 2.94-1.5.13 1.17-.34 2.35-1.04 3.19-.69.85-1.83 1.51-2.95 1.42-.15-1.15.41-2.35 1.05-3.11z"/></svg>
                macOS
              </button>
              <button className={`os-tab ${os === 'linux' ? 'active' : ''}`} onClick={() => setOs('linux')}>
                <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor"><path d="M12.504 0c-.155 0-.315.008-.48.021-4.226.333-3.105 4.807-3.17 6.298-.076 1.092-.3 1.953-1.05 3.02-.885 1.051-2.127 2.75-2.716 4.521-.278.832-.41 1.684-.287 2.489a.424.424 0 00-.11.135c-.26.268-.45.6-.663.839-.199.199-.485.267-.797.4-.313.136-.658.269-.864.68-.09.189-.136.394-.132.602 0 .199.027.4.055.536.058.399.116.728.04.97-.249.68-.28 1.145-.106 1.484.174.334.535.47.94.601.81.2 1.91.135 2.774.6.926.466 1.866.67 2.616.47.526-.116.97-.464 1.208-.946.587-.003 1.23-.269 2.26-.334.699-.058 1.574.267 2.577.2.025.134.063.198.114.333l.003.003c.391.778 1.113 1.368 1.884 1.43.871.074 1.726-.457 2.14-1.29.642-.148 1.024-.357 1.228-.68.199-.323.155-.775-.09-1.228-.084-.16-.151-.354-.199-.515-.048-.16-.101-.272-.052-.394.067-.18.327-.381.65-.645.324-.264.726-.596.96-1.133.466-1.073-.17-1.891-.928-2.488-.233-.183-.464-.348-.629-.507-.165-.16-.258-.3-.273-.493-.02-.267.167-.543.3-.847.131-.3.263-.653.235-1.062-.028-.41-.26-.827-.593-1.228-.334-.4-.798-.78-1.334-1.14-1.079-.698-1.635-1.768-1.869-2.863-.23-1.093-.198-2.239-.405-3.177-.296-1.462-1.065-2.688-2.294-3.235A3.763 3.763 0 0012.504 0z"/></svg>
                Linux
              </button>
            </div>

            {os === 'windows' && (
              <div className="install-instructions">
                <div className="instruction-card">
                  <div className="instr-num">a</div>
                  <div>
                    <p>Descarrega Git des de la web oficial:</p>
                    <a href="https://git-scm.com/download/win" target="_blank" rel="noopener noreferrer" className="download-link">
                      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/><polyline points="7 10 12 15 17 10"/><line x1="12" y1="15" x2="12" y2="3"/></svg>
                      git-scm.com/download/win
                    </a>
                  </div>
                </div>
                <div className="instruction-card">
                  <div className="instr-num">b</div>
                  <div>
                    <p>Executa l'instal·lador. Opcions recomanades:</p>
                    <ul className="check-list">
                      <li>Selecciona <strong>"Git Bash Here"</strong> (menu contextual)</li>
                      <li>Editor per defecte: <strong>Visual Studio Code</strong></li>
                      <li>Branca per defecte: <strong>main</strong> (no master)</li>
                      <li>Deixa la resta d'opcions per defecte</li>
                    </ul>
                  </div>
                </div>
                <div className="instruction-card">
                  <div className="instr-num">c</div>
                  <div>
                    <p>Verifica la instal·lacio obrint un terminal (cmd o Git Bash):</p>
                    <div className="mini-terminal">
                      <div className="terminal-line"><span className="prompt">$</span><span className="cmd">git --version</span></div>
                      <div className="terminal-line output">git version 2.44.0.windows.1</div>
                    </div>
                  </div>
                </div>
              </div>
            )}

            {os === 'mac' && (
              <div className="install-instructions">
                <div className="instruction-card">
                  <div className="instr-num">a</div>
                  <div>
                    <p>Obre el Terminal i escriu:</p>
                    <div className="mini-terminal">
                      <div className="terminal-line"><span className="prompt">$</span><span className="cmd">xcode-select --install</span></div>
                    </div>
                    <p className="note">Aixo instal·la les Command Line Tools que inclouen Git.</p>
                  </div>
                </div>
                <div className="instruction-card">
                  <div className="instr-num">b</div>
                  <div>
                    <p>Alternativament, amb Homebrew:</p>
                    <div className="mini-terminal">
                      <div className="terminal-line"><span className="prompt">$</span><span className="cmd">brew install git</span></div>
                    </div>
                  </div>
                </div>
                <div className="instruction-card">
                  <div className="instr-num">c</div>
                  <div>
                    <p>Verifica la instal·lacio:</p>
                    <div className="mini-terminal">
                      <div className="terminal-line"><span className="prompt">$</span><span className="cmd">git --version</span></div>
                      <div className="terminal-line output">git version 2.44.0</div>
                    </div>
                  </div>
                </div>
              </div>
            )}

            {os === 'linux' && (
              <div className="install-instructions">
                <div className="instruction-card">
                  <div className="instr-num">a</div>
                  <div>
                    <p>Ubuntu / Debian:</p>
                    <div className="mini-terminal">
                      <div className="terminal-line"><span className="prompt">$</span><span className="cmd">sudo apt update</span></div>
                      <div className="terminal-line"><span className="prompt">$</span><span className="cmd">sudo apt install git</span></div>
                    </div>
                  </div>
                </div>
                <div className="instruction-card">
                  <div className="instr-num">b</div>
                  <div>
                    <p>Fedora:</p>
                    <div className="mini-terminal">
                      <div className="terminal-line"><span className="prompt">$</span><span className="cmd">sudo dnf install git</span></div>
                    </div>
                  </div>
                </div>
                <div className="instruction-card">
                  <div className="instr-num">c</div>
                  <div>
                    <p>Verifica la instal·lacio:</p>
                    <div className="mini-terminal">
                      <div className="terminal-line"><span className="prompt">$</span><span className="cmd">git --version</span></div>
                      <div className="terminal-line output">git version 2.44.0</div>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>

        {/* STEP 2: Configure Git */}
        <div className="install-step">
          <div className="step-number">2</div>
          <div className="step-content">
            <h3>Configurar Git (obligatori)</h3>
            <p>Abans de fer servir Git, has de configurar el teu nom i correu. Aquesta informacio apareixera a cada commit.</p>
            <div className="mini-terminal large">
              <div className="terminal-header">
                <span className="dot red"></span>
                <span className="dot yellow"></span>
                <span className="dot green"></span>
                <span className="terminal-title">configuracio inicial</span>
              </div>
              <div className="terminal-body">
                <div className="terminal-line comment"># Configurar el teu nom (apareixera als commits)</div>
                <div className="terminal-line"><span className="prompt">$</span><span className="cmd">git config --global user.name "El Teu Nom"</span></div>
                <div className="terminal-line spacer"></div>
                <div className="terminal-line comment"># Configurar el teu correu (ha de ser el de GitHub)</div>
                <div className="terminal-line"><span className="prompt">$</span><span className="cmd">git config --global user.email "el.teu@email.com"</span></div>
                <div className="terminal-line spacer"></div>
                <div className="terminal-line comment"># Configurar la branca per defecte com "main"</div>
                <div className="terminal-line"><span className="prompt">$</span><span className="cmd">git config --global init.defaultBranch main</span></div>
                <div className="terminal-line spacer"></div>
                <div className="terminal-line comment"># Verificar la configuracio</div>
                <div className="terminal-line"><span className="prompt">$</span><span className="cmd">git config --list</span></div>
                <div className="terminal-line output">user.name=El Teu Nom</div>
                <div className="terminal-line output">user.email=el.teu@email.com</div>
                <div className="terminal-line output">init.defaultBranch=main</div>
              </div>
            </div>
            <div className="warning-box">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"/><line x1="12" y1="9" x2="12" y2="13"/><line x1="12" y1="17" x2="12.01" y2="17"/></svg>
              <p><strong>Important:</strong> El correu ha de ser el <strong>mateix</strong> que faries servir a GitHub/GitLab perque els commits quedin vinculats al teu perfil.</p>
            </div>
          </div>
        </div>

        {/* STEP 3: Install VS Code */}
        <div className="install-step">
          <div className="step-number">3</div>
          <div className="step-content">
            <h3>Instal·lar Visual Studio Code</h3>
            <p>VS Code es l'editor de codi mes popular. Te integracio nativa amb Git i moltes extensions utils.</p>
            <div className="instruction-card">
              <div className="instr-num">a</div>
              <div>
                <p>Descarrega VS Code:</p>
                <a href="https://code.visualstudio.com/" target="_blank" rel="noopener noreferrer" className="download-link">
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/><polyline points="7 10 12 15 17 10"/><line x1="12" y1="15" x2="12" y2="3"/></svg>
                  code.visualstudio.com
                </a>
              </div>
            </div>
            <div className="instruction-card">
              <div className="instr-num">b</div>
              <div>
                <p>Durant la instal·lacio a Windows, marca aquestes opcions:</p>
                <ul className="check-list">
                  <li><strong>"Add to PATH"</strong> - Per obrir VS Code des del terminal</li>
                  <li><strong>"Register as editor for supported file types"</strong></li>
                  <li><strong>"Add Open with Code" to context menu</strong></li>
                </ul>
              </div>
            </div>
          </div>
        </div>

        {/* STEP 4: VS Code Extensions */}
        <div className="install-step">
          <div className="step-number">4</div>
          <div className="step-content">
            <h3>Extensions de VS Code recomanades</h3>
            <p>Aquestes extensions fan que treballar amb Git sigui molt mes visual i facil.</p>
            <div className="extensions-grid">
              <div className="extension-card essential">
                <div className="ext-badge">Essencial</div>
                <div className="ext-header">
                  <div className="ext-icon" style={{background: '#f05032'}}>
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2"><circle cx="18" cy="18" r="3"/><circle cx="6" cy="6" r="3"/><path d="M13 6h3a2 2 0 0 1 2 2v7"/><path d="M6 9v12"/></svg>
                  </div>
                  <div>
                    <h4>GitLens</h4>
                    <span className="ext-author">GitKraken</span>
                  </div>
                </div>
                <p>Mostra qui va modificar cada linia de codi, quan i per que (git blame inline). Imprescindible.</p>
                <div className="ext-install">
                  <code>ext install eamodio.gitlens</code>
                </div>
              </div>

              <div className="extension-card essential">
                <div className="ext-badge">Essencial</div>
                <div className="ext-header">
                  <div className="ext-icon" style={{background: '#3b82f6'}}>
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2"><circle cx="12" cy="12" r="10"/><line x1="2" y1="12" x2="22" y2="12"/><path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"/></svg>
                  </div>
                  <div>
                    <h4>Git Graph</h4>
                    <span className="ext-author">mhutchie</span>
                  </div>
                </div>
                <p>Visualitza l'historial de branques i commits amb un grafic interactiu molt clar.</p>
                <div className="ext-install">
                  <code>ext install mhutchie.git-graph</code>
                </div>
              </div>

              <div className="extension-card">
                <div className="ext-header">
                  <div className="ext-icon" style={{background: '#22c55e'}}>
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2"><path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"/><polyline points="22 4 12 14.01 9 11.01"/></svg>
                  </div>
                  <div>
                    <h4>Git History</h4>
                    <span className="ext-author">Don Jayamanne</span>
                  </div>
                </div>
                <p>Veure l'historial de commits, comparar branques i cercar commits antics.</p>
                <div className="ext-install">
                  <code>ext install donjayamanne.githistory</code>
                </div>
              </div>

              <div className="extension-card">
                <div className="ext-header">
                  <div className="ext-icon" style={{background: '#6366f1'}}>
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2"><path d="M15 22v-4a4.8 4.8 0 0 0-1-3.5c3 0 6-2 6-5.5.08-1.25-.27-2.48-1-3.5.28-1.15.28-2.35 0-3.5 0 0-1 0-3 1.5-2.64-.5-5.36-.5-8 0C6 2 5 2 5 2c-.3 1.15-.3 2.35 0 3.5A5.403 5.403 0 0 0 4 9c0 3.5 3 5.5 6 5.5-.39.49-.68 1.05-.85 1.65-.17.6-.22 1.23-.15 1.85v4"/><path d="M9 18c-4.51 2-5-2-7-2"/></svg>
                  </div>
                  <div>
                    <h4>GitHub Pull Requests</h4>
                    <span className="ext-author">GitHub</span>
                  </div>
                </div>
                <p>Gestiona Pull Requests i Issues de GitHub directament des de VS Code.</p>
                <div className="ext-install">
                  <code>ext install GitHub.vscode-pull-request-github</code>
                </div>
              </div>
            </div>

            <div className="tip-box">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><circle cx="12" cy="12" r="10"/><path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3"/><line x1="12" y1="17" x2="12.01" y2="17"/></svg>
              <p><strong>Com instal·lar:</strong> A VS Code, prem <code>Ctrl+Shift+X</code> (o <code>Cmd+Shift+X</code> a Mac), cerca el nom de l'extensio i clica "Install".</p>
            </div>
          </div>
        </div>

        {/* STEP 5: Create accounts */}
        <div className="install-step">
          <div className="step-number">5</div>
          <div className="step-content">
            <h3>Crear comptes a GitHub i GitLab</h3>
            <p>Necessitaras un compte a almenys una d'aquestes plataformes per pujar el teu codi al nuvol.</p>
            <div className="accounts-grid">
              <div className="account-card">
                <div className="account-icon github-bg">
                  <svg width="32" height="32" viewBox="0 0 24 24" fill="white"><path d="M12 0c-6.626 0-12 5.373-12 12 0 5.302 3.438 9.8 8.207 11.387.599.111.793-.261.793-.577v-2.234c-3.338.726-4.033-1.416-4.033-1.416-.546-1.387-1.333-1.756-1.333-1.756-1.089-.745.083-.729.083-.729 1.205.084 1.839 1.237 1.839 1.237 1.07 1.834 2.807 1.304 3.492.997.107-.775.418-1.305.762-1.604-2.665-.305-5.467-1.334-5.467-5.931 0-1.311.469-2.381 1.236-3.221-.124-.303-.535-1.524.117-3.176 0 0 1.008-.322 3.301 1.23.957-.266 1.983-.399 3.003-.404 1.02.005 2.047.138 3.006.404 2.291-1.552 3.297-1.23 3.297-1.23.653 1.653.242 2.874.118 3.176.77.84 1.235 1.911 1.235 3.221 0 4.609-2.807 5.624-5.479 5.921.43.372.823 1.102.823 2.222v3.293c0 .319.192.694.801.576 4.765-1.589 8.199-6.086 8.199-11.386 0-6.627-5.373-12-12-12z"/></svg>
                </div>
                <h4>GitHub</h4>
                <p>La plataforma mes popular. Utilitzada per milions de projectes open source i empreses.</p>
                <a href="https://github.com/signup" target="_blank" rel="noopener noreferrer" className="account-link">Crear compte a GitHub</a>
              </div>
              <div className="account-card">
                <div className="account-icon gitlab-bg">
                  <svg width="32" height="32" viewBox="0 0 24 24" fill="white"><path d="M22.65 14.39L12 22.13 1.35 14.39a.84.84 0 0 1-.3-.94l1.22-3.78 2.44-7.51A.42.42 0 0 1 4.82 2a.43.43 0 0 1 .58 0 .42.42 0 0 1 .11.18l2.44 7.49h8.1l2.44-7.51A.42.42 0 0 1 18.6 2a.43.43 0 0 1 .58 0 .42.42 0 0 1 .11.18l2.44 7.51L23 13.45a.84.84 0 0 1-.35.94z"/></svg>
                </div>
                <h4>GitLab</h4>
                <p>Alternativa potent amb CI/CD integrat. Molt popular en empreses i universitats.</p>
                <a href="https://gitlab.com/users/sign_up" target="_blank" rel="noopener noreferrer" className="account-link">Crear compte a GitLab</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Installation;
